import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {Dialog, FlatButton, FloatingActionButton} from 'material-ui';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';
import styles from './Pages.css';
import {deletePage, getPages, resetPage} from "../../store/pages/actions";
import withTranslation from "../../hoc/withTranslation";
import {search, setOxMode} from "../../store/ui/actions";
import SearchBox from "../../components/common/SearchBox/SearchBox";
import Loading from "../../components/common/Loading/Loading";
import PageList from "../../components/page/PageList";
import {ADD_PAGE_PAGE, PAGE_PAGE} from "../../constants/routes";
import {fetchApp} from "../../store/apps/actions";
import {DisplayMode} from "../../components/report/Reports/Reports";
import {ADMIN} from "../../services/admin";
import AdminService from "../../services/admin";


export class PageListPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        match: PropTypes.object,
        currentLang: PropTypes.string
    };

    static defaultProps = {
        loading: true,
        app: null
    };

    state = {
        floatingPopoverOpened: false,
        floatingAnchorElement: null,
        openRemovePage: false,
        pageToRemove: null
    };

    componentWillMount() {
        this.props.setOxMode(DisplayMode.MODE_LIST);
        this.props.resetPage();
        this.fetchApplication();

        if (this.props.app && this.props.currentLang) {
            this.props.getPages(this.props.app, this.props.currentLang);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
            this.fetchApplication(nextProps.match.params.appId);
        }
        if (this.props.app !== nextProps.app && nextProps.app && nextProps.currentLang) {
            this.props.getPages(nextProps.app, nextProps.currentLang);
        }
    }
    // Logic

    fetchApplication(appId = null) {
        if (this.props.match) {
            let id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    filteredPages() {

        if (this.props.pages === undefined || this.props.pages === null || this.props.pages.length === 0) {
            return [];
        }

        const {searchValue} = this.props;

        if (!searchValue || searchValue.length === 0) {
            return this.props.pages;
        }

        return this.props.pages.filter((page) => {
            const includesName = page.title && page.title.includes(searchValue);
            const includesDesc = page.description && page.description.includes(searchValue);

            return includesName || includesDesc;
        });
    }

    // Handlers

    onPageClicked = (page) => {
        let url = PAGE_PAGE.replace(':appId', this.props.app.id).replace(':pageId', page.id);
        this.props.history.push(url);
    };
    onAddPageClicked = () => {
        let url = ADD_PAGE_PAGE.replace(':appId', this.props.app.id);
        this.props.history.push(url);

    };
    onSearchChanged = (event, value) => {
        this.props.search(value);
    };

    // Delete pages

    handleClosePage = () => {
        this.setState({
            openRemovePage: false,
            pageToRemove: null
        });
    };

    deletePage = () => {
        this.props.deletePage(this.props.app.id, this.state.pageToRemove.id, this.props.currentLang);
    };

    // Floating Button

    handleOpenFloatingButton = (event) => {
        event.preventDefault();

        this.setState({
            floatingPopoverOpened: true,
            floatingAnchorElement: event.currentTarget
        });
    };

    handleCloseFloatingButton = () => {
        this.setState({
            floatingPopoverOpened: false,
            floatingAnchorElement: null
        });
    };


    // Render

    toolbarContainerStyle() {
        let style = styles.toolBar.container;

        style = {
            ...style,
            ...styles.toolBar.containerList
        };

        return style;
    }

    renderToolbar() {
        return (
            <Toolbar style={this.toolbarContainerStyle()}>
                <ToolbarGroup firstChild={true} style={styles.toolBar.searchBar}>
                    <SearchBox
                        onChange={this.onSearchChanged}
                        value={this.props.searchValue}
                    />
                </ToolbarGroup>
            </Toolbar>
        );
    }

    renderList(pages) {
        let bottomNavigationBarStyle = styles.list.bottomNavigationBar;
        bottomNavigationBarStyle.paddingLeft = this.props.navLeftPadding;

        return (
            <div>
                <div style={styles.list.container}>
                    <PageList
                        app={this.props.app}
                        user={this.props.user}
                        pages={pages}
                        title={this.props.t('module.page.plural')}
                        currentLang={this.props.currentLang}
                    />
                </div>
            </div>
        );
    }

    renderDeletePageDialog(page) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleClosePage}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deletePage}
            />
        ];

        return (
            <Dialog actions={actions}
                    modal={this.props.sending}
                    open={this.state.openRemovePage}
                    onRequestClose={this.handleClosePoint}>
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                <p>
                    <div dangerouslySetInnerHTML={{
                        __html: this.props.t('module.page.delete_page_confirmation', {
                            name: page.name
                        })
                    }}/>
                </p>
                }
            </Dialog>
        );
    }

    renderFloatingButton() {
        return (
            <div>
                <FloatingActionButton
                    style={styles.floatingButton}
                    onClick={this.onAddPageClicked}
                >
                    <ContentAdd />
                </FloatingActionButton>
            </div>
        );
    }

    render() {
        // No app loading anyway
        if (!this.props.app || this.props.loading) {
            return <Loading paper={false} />
        }

        const pages = this.filteredPages() || [];

        return (
            <div style={styles.container}>
                {this.state.pageToRemove && this.renderDeletePageDialog(this.state.pageToRemove)}

                {this.renderList(pages)}

                {this.renderToolbar()}
                {AdminService.isAuthorized(ADMIN, this.props.user) && this.renderFloatingButton()}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        sending: state.pages.sending,
        loading: state.pages.pending,
        pages: state.pages.content,
        user: state.auth.content,
        currentLang: state.ui.currentLang,
        navLeftPadding: state.ui.leftPadding,
        searchValue: state.ui.search,
        listMode: state.ui.oxListMode
    };

    if (state.apps.currentApplication) {
        props.app = state.apps.currentApplication;
    }

    if (!ownProps.mode) {
        props.mode = state.ui.oxMode
    }

    if (!ownProps.listMode) {
        props.listMode = state.ui.oxListMode
    }

    return props;
}

export default connect(mapStateToProps, {
    getPages,
    fetchApp,
    search,
    deletePage,
    resetPage,
    setOxMode
})(withRouter(withTranslation(PageListPage)));



// WEBPACK FOOTER //
// src/containers/page/PageListPage.js